import React, { useEffect, useState } from "react";
import * as httpClient from "../../util/httpClient";
import { useDispatch, useSelector } from "react-redux";
import * as LoginActions from "../../store/loginService/actions";
import * as ForgotPasswordAction from "../../store/forgotPasswordService/actions";
import { useForm } from "react-hook-form";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import NeedHelp from "./NeedHelp";
import * as Service from "../../store/service";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const ValidatePassword = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [state, setState] = useState({ password: "", confirmNewPassword: "", firstInteractionDone: false });
    const [rememberThisDevice, setRememberThisDevice] = useState(false);
    const { register, errors, handleSubmit, watch } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const isIdfPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isIdfPartner
            ? state.configurationState.configuration.partnerConfig.isIdfPartner
            : false
    );
    const email = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.loginUserName
            ? state.loggedInUser.userInfo.loginUserName
            : state.forgotPasswordState && state.forgotPasswordState.email
            ? state.forgotPasswordState.email
            : state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.EmailAddress
            ? state.loggedInUser.userInfo.EmailAddress
            : ""
    );
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const errMsg = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.errorMessage) || "");
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    useEffect(() => {
        window.scrollTo(0, 0);
        setLanguage();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const setLanguage = () => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                            .split(";")
                            .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                            .split("=")[1]
                            ? document.cookie
                                .split(";")
                                .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    };
    const onSubmit = (data: any) => {
        const requestBody = {
            password: data.password,
            confirmPassword: data.confirmNewPassword,
            Email: email,
        };

        window.addToDataLayer({ event: "Reset Password" });

        const newPassword = data.password;
        setLoading(true);

        httpClient
            .sendRequest("POST", `web/forgot-password/reset-password`, requestBody)
            .then((data) => {
                if (data["isSuccess"]) {
                    Service.getPartnerMigrationStatus(partnerID)
                        .then((status) => {
                            if (status == true || isIdfPartner == true) {
                                dispatch(ForgotPasswordAction.actionCreators.addUserData(data["userId"].toString(), data["email"]));
                                login(data["email"], newPassword, data.addSecurityQuestion);
                            } else {
                                //let location = window.location.protocol + '//' + window.location.origin;
                                let location = window.location.origin;
                                window.location.href = location;
                            }
                        })
                        .catch(function (error) {
                            setLoading(false);
                        });
                }
            })
            .catch(function (error) {
                setLoading(false);
            });
    };

    const login = (email: string, password: string, addSecurityQuestion: boolean) => {
        const requestBody = {
            EmailAddress: email,
            Password: password,
            CaptchaValue: "",
        };

        setLoading(true);

        httpClient
            .sendRequest("POST", "web/login/UserLogin", requestBody)
            .then((data) => {
                if (data.isValidUser) {
                    data.EmailAddress = email;
                    const request = {
                        isSaveCookie: rememberThisDevice,
                    };
                    httpClient.sendRequest("POST", "web/login/RememberThisDevice", request).then((data1) => {
                        if (data1.isSuccess) {
                            dispatch(ConfigurationActions.actionCreators.requestCountryList());
                            dispatch(LoginActions.actionCreators.authenticateForgotPasswordFlow(data, props.history, addSecurityQuestion));
                        } else {
                            setLoading(false);
                        }
                    });
                } else {
                    setLoading(false);
                }
            })
            .catch(function (error) {
                setLoading(false);
            });
    };

    const validation = {
        minLengthCharacter: (val: any) => /^.{12,}$/.test(val),
        containsCapitalLetter: (val: any) => /.*[A-Z].*/.test(val),
        containsSpecialLetter: (val: any) => /[*@!#%&()^~{}$\-_+=\[\]\|;:"'<,>\.\?]+/.test(val),
        containsSmallLetter: (val: any) => /.*[a-z].*/.test(val),
        containsNumber: (val: any) => /\d/.test(val),
    };

    const validationMessage: Record<string, string> = {
        minLengthCharacter: tLang("resetPassword.validationMessages.minLengthCharacter"),
        containsCapitalLetter: tLang("resetPassword.validationMessages.containsCapitalLetter"),
        containsSmallLetter: tLang("resetPassword.validationMessages.containsSmallLetter"),
        containsNumber: tLang("resetPassword.validationMessages.containsNumber"),
        containsSpecialLetter: tLang("resetPassword.validationMessages.containsSpecialLetter"),
    };

    const errorMsgDict = {       
        "For your security, you are required to update your password a minimum of once every 365 days. Since that period of time has passed, you must reset your password now.":
            "Pour votre sécurité, vous devez mettre à jour votre mot de passe au moins une fois tous les 365 jours. Cette période étant écoulée, vous devez réinitialiser votre mot de passe maintenant.",
        "For your security, you must reset your password now.":
        "Pour votre sécurité, vous devez réinitialiser votre mot de passe maintenant."
    }
    const getErrorMsg = (errorMsg) => {
        const preferredLanguage = sessionStorage.getItem('preferredLanguage');
        let languageId = (preferredLanguage === 'en') ? 1 : ((preferredLanguage === 'fr') ? 2 : 1);
        if (errorMsgDict !== null && errorMsgDict.hasOwnProperty(errorMsg)) {
            if (languageId === 1) {
                return errorMsg;
            } else {
                return errorMsgDict[errorMsg];
            }
        } else {
            return errorMsg;
        }
    }

    return (
        <React.Fragment>
            <div id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                {tLang("resetPassword.titlePage")}
                            </h1>
                        </div>
                    </div>
                    <div className="row margin-vertical-xl" id="content">
                        <div className="col-xs">
                            <div className={loading ? "loading box box-has-shadow box-xs offset-padding" : "box box-has-shadow box-xs offset-padding"}>
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="key" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("resetPassword.title")}</h2>
                                        </div>
                                    </div>
                                    {errMsg && (
                                        <div className="box-description">
                                            <p>{getErrorMsg(errMsg)}</p>
                                        </div>
                                    )}
                                </div>
                                <div className="box-content">
                                    <form id="form-forgot-password" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form-row">
                                            <div className="form-label">
                                                <label htmlFor="password-label">{tLang("resetPassword.labels.password")}</label>
                                            </div>
                                            <div className="form-input">
                                                <input
                                                    type="password"
                                                    autoComplete="off"
                                                    className={errors.password ? "status-error inputbox" : "inputbox"}
                                                    id="password-label"
                                                    onBlur={(e) => setState({ ...state, firstInteractionDone: true })}
                                                    name="password"
                                                    ref={register({ validate: validation })}
                                                />
                                                {Object.keys(validationMessage).map((key, value) => {
                                                    let validationResultClass;

                                                    if (!state.firstInteractionDone && errors && !errors.password) {
                                                        validationResultClass = "validation-default";
                                                    }

                                                    if (state.firstInteractionDone && errors && !errors.password) {
                                                        validationResultClass = "validation-true";
                                                    }
                                                    if (state.firstInteractionDone && errors && errors.password && errors.password.types) {
                                                        validationResultClass = errors.password.types[key] ? "validation-false" : "validation-true";
                                                    }
                                                    if (!state.firstInteractionDone && errors && errors.password && errors.password.types) {
                                                        validationResultClass = errors.password.types[key] ? "validation-false" : "validation-true";
                                                    }
                                                    return (
                                                        <span className={validationResultClass}>
                                                            <p key={key}>{validationMessage[key]}</p>
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-label">
                                                <label htmlFor="confirm-password-label">{tLang("resetPassword.labels.confirmPassword")}</label>
                                            </div>
                                            <div className="form-input">
                                                <input
                                                    type="password"
                                                    id="confirm-password-label"
                                                    className={errors.confirmNewPassword ? "status-error inputbox" : "inputbox"}
                                                    ref={register({
                                                        required: true,
                                                        validate: (value) => value === watch("password") || "Confirm password do not match.",
                                                    })}
                                                    name="confirmNewPassword"
                                                />
                                                {errors.confirmNewPassword && errors.confirmNewPassword.type === "validate" && (
                                                    <span className="form-error">
                                                        <p>{tLang("resetPassword.errorMessages.msg1")}</p>
                                                    </span>
                                                )}
                                                {errors.confirmNewPassword && errors.confirmNewPassword.type === "required" && (
                                                    <span className="form-error">
                                                        <p>{tLang("resetPassword.errorMessages.msg2")}</p>
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="form-row">
                                            <div className="form-input">
                                                <label className="form-checkbox-label" htmlFor="remember_me">
                                                    <input
                                                        type="checkbox"
                                                        name="isChecked"
                                                        id="remember_me"
                                                        onChange={() => setRememberThisDevice(!rememberThisDevice)}
                                                        checked={rememberThisDevice}
                                                    />
                                                    <span className="form-checkbox-label-text">{tLang("resetPassword.rememberDevice")}</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="margin-bottom-s"></div>

                                        <div className="form-row">
                                            <button type="submit" className="btn-default btn-primary">
                                                <span className="btn-text">{tLang("resetPassword.submitBtn")}</span>
                                            </button>
                                        </div>

                                        {!errMsg && (
                                            <div className="form-row">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Back to Login" });
                                                        props.history.push("/");
                                                    }}
                                                >
                                                    <span className="btn-text">{tLang("resetPassword.backToLogin")}</span>
                                                </button>
                                            </div>
                                        )}
                                        {!errMsg && !isLife360PartnerId && (
                                            <>
                                                <div className="line-divider margin-vertical-l"></div>

                                                <NeedHelp />
                                            </>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ValidatePassword;
